import * as React from 'react';
import { Box } from '@mui/material';
import { Public, School, WorkspacePremium, Category, Business } from '@mui/icons-material';
import Country from '../../components/Country';
import InstitutionType from '../../components/InstitutionType';
import Degree from '../../components/Degree';
import Institution from '../../components/Institution';
import AdminDepartmentCategory from '../../components/AdminDepartmentCategory';
import TabSelector from '../../components/TabSelector';

const categoryOptions = [
    { name: 'Countries', value: 'Countries', icon: <Public /> },
    { name: 'Institutions', value: 'Institutions', icon: <Business /> },
    { name: 'Institution Types', value: 'Institution Types', icon: <School /> },
    { name: 'Admin Department Categories', value: 'Admin Department Categories', icon: <Category /> },
    { name: 'Degrees', value: 'Degrees', icon: <WorkspacePremium /> }
];


export default function MultipleSelectPlaceholder() {
    const [category, setCategory] = React.useState("Countries");

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                width: '100%',
                minHeight: '100%'
            }}
            className='fade-in'
        >
            <Box sx={{ width: '100%' }}>
                <TabSelector
                    items={categoryOptions}
                    value={category}
                    setValue={setCategory}
                    variant="scrollable"
                />
            </Box>
            <Box sx={{
                backgroundColor: 'background.paper',
                borderRadius: '12px',
                boxShadow: 1,
                p: { xs: 1.5, sm: 2.5 },
                transition: 'all 0.3s ease',
                width: '100%',
                flex: 1,
                overflow: 'hidden'
            }}>
                {category === "Countries" && <Country />}
                {category === "Institution Types" && <InstitutionType />}
                {category === "Degrees" && <Degree />}
                {category === 'Admin Department Categories' && <AdminDepartmentCategory />}
                {category === "Institutions" && <Institution />}
            </Box>
        </Box>
    );
}
